// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownSquareOutlinedSvg from "@fishx/icons-svg/es/asn/DownSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareOutlinedSvg
  }));
};

DownSquareOutlined.displayName = 'DownSquareOutlined';
export default React.forwardRef(DownSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownSquareOutlined.js
// module id = 2466
// module chunks = 0